import includes from 'lodash/includes';
import reject from 'lodash/reject';
import last from 'lodash/last';
import findIndex from 'lodash/findIndex';
import {
    DELETE_IMAGE_SUCCESS,
    DELETE_MULTIPLE_IMAGES_SUCCESS,
    RESET_SELECTION,
    SELECTION_NAV_DRAG,
    TOGGLE_SELECT_IMAGE
} from '../actions/ImageActions';
import {isDemoAction} from './demo';

export const selectedImagesReducer = (state, action) => {
    switch (action.type) {
        case TOGGLE_SELECT_IMAGE: {
            if (includes(state, action.id)) {
                return reject(state, id => id === action.id);
            }
            if (!action.multi || state.length === 0) {
                return [...state, action.id];
            }
            const lastSelectedId = last(state);
            const lastSelectedIdx = findIndex(action.images, img => img.id === lastSelectedId);
            const currentIdx = findIndex(action.images, img => img.id === action.id);
            const incr = currentIdx > lastSelectedIdx ? 1 : -1;
            const add = [];
            for (let i = lastSelectedIdx; i !== currentIdx; i += incr) {
                if (!includes(state, action.images[i].id)) {
                    add.push(action.images[i].id);
                }
            }
            add.push(action.images[currentIdx].id);
            return [...state, ...add];
        }
        case RESET_SELECTION: {
            return [];
        }
        case DELETE_IMAGE_SUCCESS: {
            return reject(state, id => id === action.id);
        }
        case DELETE_MULTIPLE_IMAGES_SUCCESS: {
            return reject(state, id => action.ids.includes(id));
        }
        default:
            break;
    }
    return state;
};

const SELECTION_NAV_KEY = 'selectionNav';

const navInitialState = JSON.parse(localStorage.getItem(SELECTION_NAV_KEY)) || {
    x: 0,
    y: 0
};

function selectionNavReducer(state = navInitialState, action) {
    switch (action.type) {
        case SELECTION_NAV_DRAG: {
            return {...state, x: action.x, y: action.y};
        }
        default:
            break;
    }
    return state;
}

export function selectedImages(state = {images: [], nav: navInitialState}, action) {
    if (isDemoAction(action)) {
        return state;
    }
    let newState = state;
    const nav = selectionNavReducer(state.nav, action);
    if (nav !== state.nav) {
        localStorage.setItem(SELECTION_NAV_KEY, JSON.stringify(nav));
        newState = {...newState, nav};
    }

    const oldImages = state.images || [];
    const images = selectedImagesReducer(oldImages, action);
    if (images !== oldImages) {
        newState = {...newState, images};
    }

    return newState;
}

export const getSelectedImageIds = state => state.selectedImages.images;



// WEBPACK FOOTER //
// ./src/reducers/selectedImages.js